import eControllerTypes from '../eControllerTypes';

export default {
  ERCCT_START_POPUP: `${eControllerTypes.ECT_REALITY_CHECK}__start_popup`,
  ERCCT_MAIN_POPUP: `${eControllerTypes.ECT_REALITY_CHECK}__main_popup`,
}
